import { TeamsConstantNames } from 'collections/Teams';
import { UserOption } from 'components/shared/SelectUser';
import { useMemo } from 'react';
import { useTeamWithUsersQuery } from 'utils/graphql/queries/__generated__/teamWithUsers';

interface UseGetPsmUserOptions {
  skip?: boolean;
}

/** Options for the PSM select — members of the "Partner Success Managers" team */
export const useGetPsmUserOptions = ({ skip }: UseGetPsmUserOptions = {}) => {
  const { data, loading } = useTeamWithUsersQuery({
    variables: { constantName: TeamsConstantNames.PartnerSuccessManagers },
    skip,
  });

  const options: UserOption[] = useMemo(
    () =>
      data?.team.users.map((teamUser) => ({
        value: teamUser.user.id,
        label: teamUser.user.name,
        imageUrl: teamUser.user.imageUrl,
      })) || [],
    [data],
  );

  return { options, loading };
};
